<template>
  <generic-modal
    :title="$t('process order')"
    ref="generic_modal"
    :is_wide="true"
  >
    <div class="title is-5 is-pulled-right">
      <div class="has-text-primary has-text-right">
        {{ $t("total") }} {{ format_currency(meta.total) }}
      </div>
      <div class="has-text-warning has-text-right">
        {{ meta.payment_method_title }}
      </div>
    </div>
    <div class="title is-5 mb-5">
      {{ $t("order") }} <span class="has-text-success">{{ meta.number }}</span>
    </div>

    <div class="columns mt-6">
      <div class="column">
        <div class="title is-5 has-text-centered">
          {{ $t("sale register") }}
        </div>

        <div v-if="meta && meta.line_items">
          <div class="title is-5">{{ $t("items") }}</div>
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>{{ $t("product") }}</th>
                <th>{{ $t("total") }}</th>
                <th>{{ $t("modul product") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in meta.line_items">
                <td>{{ item.quantity }} x {{ item.name }}</td>
                <td>{{ format_currency(item.total) }}</td>
                <td>
                  <div class="field">
                    <span v-if="item.modul_homologation">
                      {{ item.modul_homologation.modul_product.name }}
                    </span>
                    <span class="title is-6" v-else>
                      <span class="icon has-text-warning">
                        <i class="fa fa-exclamation-triangle"></i>
                      </span>
                      <span class="has-text-danger">{{
                        $t("homologation not found")
                      }}</span>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="columns">
            <div class="column">
              <div
                class="button is-rounded is-primary"
                :disabled="!is_order_valid || meta.sale_id"
                v-if="!meta.sale_id"
                @click="create_sale"
              >
                <span class="icon">
                  <i class="fa fa-credit-card"></i>
                </span>
                <span>{{ $t("create sale") }}</span>
              </div>
              <div class="button is-rounded is-warning" v-if="meta.sale_id">
                <span class="icon">
                  <i class="fa fa-check"></i>
                </span>
                <span>{{ $t("sale generated") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="is-divider-vertical"></div>
      <!-- <div class="column">
        <div class="title is-5 has-text-centered">
          {{ $t("billing") }}
        </div>
        <div class="field">
          <label class="label">{{ $t("nit") }}</label>
          <div class="control has-icons-left">
            <input class="input" type="text" />
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </div>
        </div>
      </div> -->
      <div class="column">
        <div class="title is-4">{{ $t("billing") }}</div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("nit") }}</label>
              <div class="control has-icons-left">
                <input class="input" type="text" v-model="billing_data.nit" />
                <span class="icon is-small is-left">
                  <i class="fa fa-id-card"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("email") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  v-model="billing_data.email"
                /><span class="icon is-small is-left">
                  <i class="fa fa-at"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("municipality") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  v-model="billing_data.municipality"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("address") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  v-model="billing_data.address"
                /><span class="icon is-small is-left">
                  <i class="fa fa-home"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("name") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  placeholder="Luis Robledo"
                  v-model="billing_data.name"
                /><span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("zip code") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  v-model="billing_data.zip_code"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-map-marker"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("department") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  v-model="billing_data.department"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("emit") }}</label>
              <div
                class="button is-primary is-rounded"
                @click="emit_bill"
                v-if="!meta.bill_id"
                :disabled="!is_billing_valid || meta.bill_id"
              >
                <span class="icon">
                  <i class="fa fa-print"></i>
                </span>
                <span>{{ $t("emit") }}</span>
              </div>
              <div class="button is-warning is-rounded" v-if="meta.bill_id">
                <span class="icon">
                  <i class="fa fa-check"></i>
                </span>
                <span>{{ $t("bill emitted") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "WooCommerceProcessOrderModal",
  components: { GenericModal },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      billing_data: {
        nit: "",
        email: "",
        municipality: "",
        address: "",
        name: "",
        zip_code: "",
        department: "",
      },
    };
  },
  props: {},
  computed: {
    is_order_valid() {
      let v = this;
      let items = v.meta.line_items || [];
      let invalid = items.find((item) => {
        return !item.modul_woocommerce_product || !item.modul_homologation;
      });
      return !invalid;
    },
    is_billing_valid() {
      let v = this;
      return (
        v.billing_data.nit &&
        v.billing_data.email &&
        v.billing_data.municipality &&
        v.billing_data.address &&
        v.billing_data.name &&
        v.billing_data.zip_code &&
        v.billing_data.department &&
        v.is_order_valid
      );
    },
  },
  methods: {
    change_active_tab,
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/woocommerce/order", { uuid: uuid })
        .then((order) => {
          v.meta = order.json_data;
          v.meta.uuid = uuid;
          if (order.sale_id) v.meta.sale_id = order.sale_id;
          if (order.bill_id) v.meta.bill_id = order.bill_id;
          if (v.meta.billing) {
            v.billing_data.name = `${v.meta.billing.first_name} ${v.meta.billing.last_name}`;
            v.billing_data.email = v.meta.billing.email;
            v.billing_data.zip_code = v.meta.billing.postcode;
            v.billing_data.address = v.meta.billing.address_1;
            v.billing_data.municipality = v.meta.billing.city;
            v.billing_data.department = v.meta.billing.state;
          }
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });

      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
    },
    create_sale() {
      let v = this;
      v.$root.loader(true);
      put("/woocommerce/order/sale", { uuid: v.meta.uuid })
        .then((sale_id) => {
          v.meta.sale_id = sale_id;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    emit_bill() {
      let v = this;
      v.$root.loader(true);
      put("/woocommerce/order/billing", {
        uuid: v.meta.uuid,
        billing: v.billing_data,
      })
        .then((bill_id) => {
          v.meta.bill_id = bill_id;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
